export const experienceData = [
  {
    id: 1,
    company: "Bit Brothers",
    jobtitle: "Backend Developer Intern",
    startYear: "2022",
    endYear: "2022"
  },
  {
    id: 2,
    company: "FlameCloud.Co.UK",
    jobtitle: "FullStack Developer Intern",
    startYear: "2023",
    endYear: "Current"
  }
  //   {
  //     id: 3,
  //     company: "Wonka Industries",
  //     jobtitle: "Marketing",
  //     startYear: "2020",
  //     endYear: "Present"
  //   }
];
